export enum SmsTag {
  CORE = 'core',
  MARKETING = 'marketing',
  TRANSACTIONAL = 'transactional',
}
